// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetPaymentReportHistoryHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory,
  RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  RentCreditReportPaymentHistoryWebApiRequestDto,
  RentCreditReportWebApiPaymentReportHistoryResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Options = UseQueryOptions<
  RentCreditReportWebApiPaymentReportHistoryResponseDto,
  unknown,
  RentCreditReportWebApiPaymentReportHistoryResponseDto,
  Array<string | RentCreditReportPaymentHistoryWebApiRequestDto>
>;

const RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_GetKey = (
  postData: RentCreditReportPaymentHistoryWebApiRequestDto,
) => [RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Path, postData];

/**
 * Get Payment Report History
 */
export const useRentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory = (
  postData: RentCreditReportPaymentHistoryWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_GetKey(postData),
    queryFn: () => RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory(postData, httpClient),
  });
};
useRentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory.getKey =
  RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_GetKey;
